var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c("div", { staticClass: "ibox float-e-margins set-ibox" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ibox-content set-ibox-content" },
        [
          _c(
            "el-form",
            {
              ref: "formInline",
              staticClass: "form-horizontal m-t",
              attrs: {
                rules: _vm.validation,
                model: _vm.formInline,
                "label-width": "100px",
                "label-position": "right"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "身份证号码：", prop: "idCard" } },
                [
                  _c(
                    "el-col",
                    { staticStyle: { width: "84%" }, attrs: { span: 18 } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入身份证", maxlength: "18" },
                        model: {
                          value: _vm.formInline.idCard,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "idCard", $$v)
                          },
                          expression: "formInline.idCard"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { span: 1, offset: 1 }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", span: 5, offset: 1 },
                          on: {
                            click: function($event) {
                              _vm.checkIDCard(_vm.formInline.idCard)
                            }
                          }
                        },
                        [_vm._v("查重")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { span: 24, type: "flex" } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "50%" },
                      attrs: { label: "姓名：", prop: "childName", span: 12 }
                    },
                    [
                      _c(
                        "el-col",
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入姓名",
                              maxlength: "8"
                            },
                            model: {
                              value: _vm.formInline.childName,
                              callback: function($$v) {
                                _vm.$set(_vm.formInline, "childName", $$v)
                              },
                              expression: "formInline.childName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "50%" },
                      attrs: {
                        label: "性别：",
                        prop: "sex",
                        span: 9,
                        offset: 3
                      }
                    },
                    [
                      _c(
                        "el-col",
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { placeholder: "请选择性别" },
                              model: {
                                value: _vm.formInline.sex,
                                callback: function($$v) {
                                  _vm.$set(_vm.formInline, "sex", $$v)
                                },
                                expression: "formInline.sex"
                              }
                            },
                            [
                              _c("el-option", {
                                key: "男",
                                attrs: { label: "男", value: "男" }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                key: "女",
                                attrs: { label: "女", value: "女" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "生日：", prop: "birthday" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "date",
                          placeholder: "选择日期",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.formInline.birthday,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "birthday", $$v)
                          },
                          expression: "formInline.birthday"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "所属幼儿园：", prop: "kindOrgID" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            filterable: "",
                            placeholder: "请选择幼儿园"
                          },
                          on: {
                            change: function($event) {
                              _vm.changeKind()
                            }
                          },
                          model: {
                            value: _vm.formInline.kindOrgName,
                            callback: function($$v) {
                              _vm.$set(_vm.formInline, "kindOrgName", $$v)
                            },
                            expression: "formInline.kindOrgName"
                          }
                        },
                        _vm._l(_vm.selectKind, function(item) {
                          return _c("el-option", {
                            key: item.orgKindID,
                            attrs: {
                              label: item.fullName,
                              value: item.orgKindID
                            }
                          })
                        })
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "联系人：" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入联系人姓名",
                          maxlength: "18"
                        },
                        model: {
                          value: _vm.formInline.relation,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "relation", $$v)
                          },
                          expression: "formInline.relation"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "手机号码：", prop: "relationPhone" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入联系人手机号码",
                          maxlength: "18"
                        },
                        model: {
                          value: _vm.formInline.relationPhone,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "relationPhone", $$v)
                          },
                          expression: "formInline.relationPhone"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "地址：", prop: "provinceID" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择省" },
                          on: {
                            change: function($event) {
                              _vm.onChangePro(_vm.formInline.provinceID)
                            }
                          },
                          model: {
                            value: _vm.formInline.provinceID,
                            callback: function($$v) {
                              _vm.$set(_vm.formInline, "provinceID", $$v)
                            },
                            expression: "formInline.provinceID"
                          }
                        },
                        _vm._l(_vm.selectpro, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id + "" }
                          })
                        })
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 7, offset: 1 } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择市" },
                          on: {
                            change: function($event) {
                              _vm.onChangeCity(_vm.formInline.cityID)
                            }
                          },
                          model: {
                            value: _vm.formInline.cityID,
                            callback: function($$v) {
                              _vm.$set(_vm.formInline, "cityID", $$v)
                            },
                            expression: "formInline.cityID"
                          }
                        },
                        _vm._l(_vm.selectcity, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id + "" }
                          })
                        })
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 7, offset: 1 } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择区" },
                          model: {
                            value: _vm.formInline.countryID,
                            callback: function($$v) {
                              _vm.$set(_vm.formInline, "countryID", $$v)
                            },
                            expression: "formInline.countryID"
                          }
                        },
                        _vm._l(_vm.selectarea, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id + "" }
                          })
                        })
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入地址", maxlength: "250" },
                        model: {
                          value: _vm.formInline.street,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "street", $$v)
                          },
                          expression: "formInline.street"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-primary",
                      on: {
                        click: function($event) {
                          _vm.editTo()
                        }
                      }
                    },
                    [_vm._v("确定")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-default",
                      on: {
                        click: function($event) {
                          _vm.close()
                        }
                      }
                    },
                    [_vm._v("取消")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ibox-title" }, [
      _c("h5", [_vm._v("修改儿童记录")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b4efb70", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b4efb70","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/childmgr/childsmgrEdit.vue
// module id = null
// module chunks = 